import React from 'react';
import { Home, TrendingUp, User, Shield, Coffee, LogIn, LogOut, Tv } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

const Sidebar = ({ currentView, setCurrentView, onLoginClick }) => {
  const { user, logout } = useAuth();
  const menuItems = [
    { id: 'home', label: '主页', icon: Home },
    { id: 'danmaku', label: '弹幕大屏', icon: Tv },
    { id: 'ranking', label: '排行榜', icon: TrendingUp },
    { id: 'my-posts', label: '我的吐槽', icon: User },
    { id: 'anonymous', label: '匿名保护', icon: Shield }
  ];

  return (
    <div className="fixed left-0 top-0 h-full w-64 bg-slate-900 border-r border-slate-800 p-6">
      {/* Logo */}
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <Coffee className="w-8 h-8 text-terminal-green" />
          <h1 className="text-xl font-bold terminal-text">恶心爆了</h1>
        </div>
        <p className="text-xs text-slate-500 italic">职场避雷针 · 打工人基地</p>
      </div>

      {/* Navigation */}
      <nav className="space-y-2">
        {menuItems.map(item => {
          const Icon = item.icon;
          const isActive = currentView === item.id;

          return (
            <button
              key={item.id}
              onClick={() => setCurrentView(item.id)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-all ${isActive
                  ? 'bg-green-900 text-terminal-green border border-green-500 shadow-lg'
                  : 'text-slate-400 hover:text-slate-200 hover:bg-slate-800'
                }`}
            >
              <Icon className="w-5 h-5" />
              <span className="font-medium">{item.label}</span>
            </button>
          );
        })}
      </nav>

      {/* Status */}
      <div className="mt-8 p-4 bg-slate-800 rounded-lg border border-slate-700">
        {user ? (
          <>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-2 h-2 bg-terminal-green rounded-full animate-pulse"></div>
              <span className="text-sm text-terminal-green">已登录</span>
            </div>
            <p className="text-xs text-slate-400 mb-3">
              {user.nickname || user.username}
            </p>
            <button
              onClick={logout}
              className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg text-sm text-slate-300"
            >
              <LogOut className="w-4 h-4" />
              退出登录
            </button>
          </>
        ) : (
          <>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-2 h-2 bg-terminal-green rounded-full animate-pulse"></div>
              <span className="text-sm text-terminal-green">匿名模式</span>
            </div>
            <p className="text-xs text-slate-500 mb-3">
              登录后可发布吐槽
            </p>
            <button
              onClick={onLoginClick}
              className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-terminal-green hover:bg-green-400 rounded-lg text-sm text-slate-900 font-medium"
            >
              <LogIn className="w-4 h-4" />
              登录 / 注册
            </button>
          </>
        )}
      </div>

      {/* Quick Stats */}
      <div className="mt-6 space-y-3">
        <div className="text-center">
          <div className="text-2xl font-bold text-warning-orange">1,247</div>
          <div className="text-xs text-slate-500">今日吐槽数</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-danger-red">89</div>
          <div className="text-xs text-slate-500">本周槽王</div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;